/**importing the baseurl from Axios */
import { setData } from '../API/generalAPI'
import TS from '../API/TS'

/**authenticate will make a post ajax call to confirm the users credintals and return a session token */
export const authenticate = (obj) => {
  return TS.post('/user/log_in', setData(obj))
}

export const forgotPassword = (username) => {
  return TS.post(`/utility/reset_password?resetUserId=${username}`)
}

/**killsession will make a post ajax call to close the session and log the user out */
export const killSession = () => {
  return TS.post('/logout')
}
